import React from "react";
import Loading from "../Loading";
import MiniaturaItem from "../MiniaturaItem";

const Miniaturas = ({title,listArticulos,showPrice,catSelect}) => {
    //let listArticulosSort = listArticulos === null ? listArticulos : listArticulos.sort((a, b) => 0.5 - Math.random());
    
    return (
        <div className="container galeria">
            <div className="row galeria__title">
                <h1>{title}</h1>
            </div>
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4">
                {
                    listArticulos === null
                    ?   <Loading/>
                    :   listArticulos.map( (item,i) => 
                            item.activo &&
                                <MiniaturaItem
                                    item={item}
                                    key={"minItem_"+i}
                                    showPrice={showPrice}
                                    catSelect={catSelect}
                                />
                            )
                }
            </div>
        </div>
    );
};

export default Miniaturas;